/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import ReservationSegmentEvent from '../../event/ReservationSegmentEvent'

class EditStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return { reservation_id: null }
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationSegmentEvent.fetch:
        return { ...state, reservation_id: payload.reservation_id }
      default:
        return state
    }
  }
}

export default new EditStore()
